import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Icon, Spacing, Currency, Text, FlatButton } from '@reservamos/elements';
import snackIcon from 'images/icons/snacks-icon.png';
import useCurrencyConfig from '../../hooks/whitelabel/useCurrencyConfig';

/**
 * SnacksSummary component.
 * Render a summary box showing snacks and beverages with item count and total price.
 * @param {object} props - price, itemCount, onViewDetails.
 * @param {number} props.price - The total price for snacks and beverages.
 * @param {number} props.itemCount - The number of items selected.
 * @param {function} props.onViewDetails - Callback function when the view details button is clicked.
 */
const SnacksSummary = ({ price = 0, itemCount = 0, onViewDetails }) => {
  const { t } = useTranslation('general');
  const { currency } = useCurrencyConfig();

  return (
    <Box borderRadius="M" hasShadow paddingHorizontal="S" paddingVertical="S">
      <div className="w-full flex justify-between items-center">
        <Spacing alignItems="center" size="S">
          <Icon type={snackIcon} size="XL" mobileSize="L" />
          <Spacing vertical size="XS" alignItems="flex-start">
            <Text weight="semibold">{t('snacks_summary.title')}</Text>
            <FlatButton text={t('snacks_summary.view_details')} size="S" onClick={onViewDetails} />
          </Spacing>
        </Spacing>
        <Spacing size="S">
          <span className="bg-accent-regular rounded-full justify-center items-center flex h-7 w-7">
            <Text elementType="span" color="white" weight="semibold">
              {itemCount}
            </Text>
          </span>
          <Currency
            size="L"
            mobileSize="M"
            price={price}
            weight="semibold"
            decimals={1}
            currency={currency}
            showCurrency
          />
        </Spacing>
      </div>
    </Box>
  );
};

SnacksSummary.propTypes = {
  price: PropTypes.number,
  itemCount: PropTypes.number,
  onViewDetails: PropTypes.func,
};

export default SnacksSummary;
